import React, { useState } from 'react';
import './LeadCaptureForm.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

const LeadCaptureForm = ({ sessionId, onClose, onSuccess }) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [preferredTime, setPreferredTime] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setErrorMsg('');

    try {
      const res = await fetch(`${BACKEND_URL}/api/leads`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, phone, interest: 'Trial class / enrollment', preferredTime, sessionId })
      });
      const data = await res.json();

      if (!res.ok) {
        setErrorMsg(data.error || 'Something went wrong. Please call us directly.');
        setStatus('error');
        return;
      }

      setStatus('success');
      if (onSuccess) onSuccess(data.message);
    } catch {
      setErrorMsg('Could not send. Please call 9595562223 directly.');
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="lead-form-card lead-form-success">
        <span className="lead-success-icon">✅</span>
        <p>We received your details! Our instructor will call you soon.</p>
        <button className="lead-dismiss-btn" onClick={onClose}>OK</button>
      </div>
    );
  }

  return (
    <div className="lead-form-card">
      <div className="lead-form-header">
        <span>📋 Book a Free Trial</span>
        <button className="lead-close-btn" onClick={onClose} aria-label="Close">×</button>
      </div>
      <p className="lead-form-subtitle">Leave your details — we'll call you to schedule your trial class.</p>
      <form onSubmit={handleSubmit} className="lead-form">
        <input
          type="text"
          placeholder="Your name"
          value={name}
          onChange={e => setName(e.target.value)}
          required
          minLength={2}
          maxLength={60}
          className="lead-input"
          disabled={status === 'loading'}
        />
        <select
          value={preferredTime}
          onChange={e => setPreferredTime(e.target.value)}
          className="lead-input"
          disabled={status === 'loading'}
        >
          <option value="">Preferred batch time</option>
          <option value="Morning">Morning batch</option>
          <option value="Evening">Evening batch</option>
          <option value="Flexible">Flexible / Any time</option>
        </select>
        <input
          type="tel"
          placeholder="Mobile number (10 digits)"
          value={phone}
          onChange={e => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
          required
          pattern="[6-9][0-9]{9}"
          className="lead-input"
          disabled={status === 'loading'}
        />
        {errorMsg && <p className="lead-error">{errorMsg}</p>}
        <button
          type="submit"
          className="lead-submit-btn"
          disabled={status === 'loading' || name.length < 2 || phone.length !== 10}
        >
          {status === 'loading' ? 'Sending…' : 'Request Callback'}
        </button>
      </form>
    </div>
  );
};

export default LeadCaptureForm;
